import React, {PureComponent, cloneElement} from 'react'
import { Scrollbars } from 'react-custom-scrollbars'
import cn from 'classnames'
import { DragDropContext } from 'react-dnd';
import HTML5Backend from 'react-dnd-html5-backend';
import axios from 'axios'
import Spinner from 'components/common/elements/Spinner'

import { showError, showSuccess } from 'services/utils'
import FileItem from './FileItem/dndContainer'
import DropField from './DropField/dndContainer'


class Import extends PureComponent {
  constructor({data}) {
    super();

    let allFields = {};
    let fileFields = [];
    _.forEach(data.columns, (label, field) => {
      allFields[field] = {
        label,
        fileField: null,
      }
    });
    _.forEach(data.headers, (field, fileField) => {
      if (field && allFields[field]) {
        allFields[field].fileField = fileField;
      } else {
        fileFields.push(fileField);
      }
    });


    this.state = {
      allFields,
      fileFields,
      filterQ: '',
      isImporting: false,
    };
  }

  setField(fileField, stField) {
    let fileFields = this.state.fileFields.slice(),
        allFields = {...this.state.allFields};

// Pull fileField from everuwhere
    fileFields = _.pull(fileFields.slice(), fileField);

    _.forEach(allFields, (data, field) => {
      if (data.fileField == fileField) {
        allFields[field] = {
          ...data,
          fileField: null,
        };
      }
    });

// set fileField
    allFields[stField] = {
      ...allFields[stField],
      fileField,
    };

    const curFileField = this.state.allFields[stField].fileField
    if (curFileField && curFileField != fileField) {
      fileFields.push(curFileField)
    }

    this.setState({
      allFields,
      fileFields,
    })
  }
  unsetField(fileField) {
    let fileFields = this.state.fileFields,
      allFields = {...this.state.allFields};

// Pull fileField from allFields
    _.forEach(allFields, (data, field) => {
      if (data.fileField == fileField) {
        allFields[field] = {
          ...data,
          fileField: null,
        };
      }
    });

    if ( fileFields.indexOf(fileField) == -1 ) {
      fileFields = fileFields.slice();
      fileFields.push(fileField)
    }

    this.setState({
      fileFields,
      allFields,
    });
  }

  import() {
    const { isImporting, allFields } = this.state;
    const { sequenceId, data, close } = this.props;

    if (isImporting) {
      return;
    }

    this.setState({isImporting: true});

    let importFiedls = {
      columns: {},
      file_type: data.object_type
    };

    if (sequenceId) {
      importFiedls.sequence_id = sequenceId;
    }

    _.forEach(allFields, (fieldData, field) => {
      if (fieldData.fileField) {
        importFiedls.columns[fieldData.fileField] = field;
      }
    });

    axios.post(`/imports/${data.id}/import`, importFiedls).then(
      response => {
        // showSuccess('');
        close();
      }, error => {
        showError(error, 'Failed to import. Try again later');
        this.setState({isImporting: false});
      }
    )
  }

  render() {
    const { data, close } = this.props;
    const { allFields, fileFields, filterQ, isImporting } = this.state;

    return (
      <div className="import-csv-modal-fields">
        <div className="import-csv-modal-cols">
          <div className="import-csv-modal-col _left">
            <div className="gs-import__heading">
              <span className="gs-text">Fields </span>
            </div>
            <Scrollbars autoHide
                        className="import-csv-modal-col-scroll"
                        autoHideTimeout={500}
                        autoHideDuration={100}
                        style={{ width: '100%', height: '100%' }}>
              { _.map(allFields, (data, field) => (
                <div className="gs-import__field _with_before" key={field}>
                  <div className="gs-import__name" >
                    <span className="gs-text _sm">{data.label}</span>
                  </div>

                  <DropField label={data.fileField}
                             setField={(fileField) => this.setField(fileField, field)}
                             unsetField={() => this.unsetField(data.fileField)}/>
                </div>
              ))}
            </Scrollbars>
          </div>

          <div className="import-csv-modal-col _right">
            <div className="gs-import__heading _no-left-bd">
              <span className="gs-text">Export CSV</span>
            </div>
            <div className="import-csv-modal-column">
              <div className="gs-import__search">
                <input value={filterQ}
                       className='gs-input _search'
                       placeholder="Search..."
                       onChange={ e => this.setState({filterQ: e.target.value}) }/>
              </div>
              <Scrollbars autoHide
                          className="import-csv-modal-col-scroll"
                          autoHideTimeout={500}
                          autoHideDuration={100}
                          style={{ width: '100%', height: '100%' }}>
                { _.map(fileFields.filter( field => {
                  return field.match(new RegExp(filterQ, 'i'));
                }), (label) => (
                  <FileItem key={label} label={label}/>
                ))}

              </Scrollbars>
            </div>
          </div>
        </div>
        <div className="gs-modal__actions gs-modal__footer">
          <button onClick={close} className="gs-btn _modern _cancel-btn _blank" role="button">
            Cancel
          </button>
          <button onClick={ () => this.import() } className="gs-btn _modern _blank" role="button">
            Ok
            { isImporting && <Spinner size={16} /> }
          </button>
        </div>
      </div>
    )
  }
}

Import.propTypes = {
};

export default DragDropContext(HTML5Backend)(Import);
